import React from "react";
import { Container, Row, Col, Spinner, Form } from "react-bootstrap";
import {
  faBriefcase,
  faChartSimple,
  faLayerGroup,
  faSackDollar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import JobCard from "./JobCard";
import "./ViewAppliedJobExtended.scss";
import useViewAppliedJobExtended from "./useViewAppliedJobExtended";
import { dateDiff } from "../../../_helpers/dateFormatter";
import { Pagination } from "antd";
import MainLayout from "../../Common/MainLayout";
function ViewAppliedJobExtended(props) {
  const {
    allJobs,
    loading,
    jobDetails,
    jobDetailsLoading,
    currentPage,
    jobCardDivParentRef,
    onViewCompany,
    onCurrentJobCardChange,
    onCurrentPageChange,
  } = useViewAppliedJobExtended();
  return (
    <MainLayout>
      <Container className="job-board-expanded-wrapper">
        <div className="pb-4 job-board-expanded footer-gap">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Row>
              <Col lg={5} xl={4} className="">
                <h2 className="d-inline-block mb-2 pb-3 mt-lg-0">
                  Showing {allJobs?.count} Jobs
                </h2>
                <div className="cards-list" ref={jobCardDivParentRef}>
                  {allJobs?.results &&
                    Array.isArray(allJobs?.results) &&
                    allJobs.results.map((item, index) => (
                      <JobCard
                        jobDetail={item?.job_details}
                        onJobCardClick={onCurrentJobCardChange}
                        activeJobCard={jobDetails.id === item.id}
                        jobCardDivParentRef={jobCardDivParentRef}
                      />
                    ))}
                </div>
                <Pagination
                  pageSize={10}
                  current={currentPage}
                  total={allJobs?.count}
                  onChange={onCurrentPageChange}
                  style={{ bottom: "0px", textAlign: "center", marginTop: 20 }}
                />
              </Col>
              <Col lg={7} xl={8} className="">
                {jobDetailsLoading ? (
                  <div className="d-flex justify-content-center align-items-center w-100">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <div className="job-expanded-info bg-white mt-3 px-4 border border-radius-10 mt-lg-5">
                    {jobDetails?.id && (
                      <div className="bottom position-relative">
                        <div className="job-meta d-flex justify-content-between align-items-center">
                          <div className="text-right ml-auto">
                            {jobDetails?.application_status === "rejected" ? (
                              <p
                                className="custom-tag fs-14  tag-rejected rounded-pill  text-capitalize"
                              >
                                {jobDetails?.application_status}
                              </p>
                            ) : (
                              <p
                                className="custom-tag fs-14 tag-applied bg-light-blue rounded-pill text-capitalize"
                              >
                                {jobDetails?.application_status}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="job-meta">
                          <div className="skills d-flex flex-wrap my-2">
                            {Array.isArray(jobDetails?.job_details && jobDetails.job_details?.skill_names) &&
                              jobDetails?.job_details && jobDetails.job_details?.skill_names &&
                              jobDetails.job_details.skill_names.length > 1 && (
                                <>
                                  <p className="font-weight-medium w-100">Key Skills</p>
                                  {Array.isArray(jobDetails?.job_details && jobDetails.job_details?.skill_names) &&
                                    jobDetails?.job_details && jobDetails.job_details?.skill_names &&
                                    jobDetails.job_details.skill_names.map((skill) => (
                                      <span className="skill text-dark bg-grey-4 text-nowrap border px-2 rounded-lg text-capitalize mr-2 mb-2">
                                        {skill}
                                      </span>
                                    ))}
                                  <p className="text-muted d-inline-block">
                                    {Array.isArray(jobDetails?.job_details && jobDetails.job_details?.skill_names) &&
                                      jobDetails?.job_details && jobDetails.job_details?.skill_names &&
                                      jobDetails.job_details.skill_names.length > 6
                                      ? "..."
                                      : null}
                                  </p>
                                </>
                              )}
                          </div>
                          <div className="mb-3">
                            <p className="font-weight-medium">Job Description</p>
                            <div
                              className="text-grey-4"
                              dangerouslySetInnerHTML={{
                                __html:
                                  jobDetails?.job_details &&
                                  jobDetails.job_details?.role_description,
                              }}
                            ></div>
                          </div>
                          <div className="mb-3">
                            <p className="font-weight-medium">Requirements</p>
                            <div
                              className="text-grey-4"
                              dangerouslySetInnerHTML={{
                                __html:
                                  jobDetails?.job_details &&
                                  jobDetails.job_details?.role_requirements,
                              }}
                            ></div>
                          </div>
                          <div className="mb-3">
                            <p className="font-weight-medium">Benefits</p>
                            <div
                              className="text-grey-4"
                              dangerouslySetInnerHTML={{
                                __html:
                                  jobDetails?.job_details &&
                                  jobDetails.job_details?.role_benefits,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </Col>
            </Row>
          )}
        </div>
      </Container>
    </MainLayout>
  );
}
export default ViewAppliedJobExtended;
